import { trackAction } from '../lib/Segment';

const trackingMiddleware = store => next => action => {
	trackAction(action);
	return next(action);
};

export default trackingMiddleware;


// WEBPACK FOOTER //
// ./src/redux/trackingMiddleware.js